// extracted by mini-css-extract-plugin
export default {"flexContainer":"Favourites_flexContainer__-wrr9","center":"Favourites_center__uM8mz","hHeader":"Favourites_hHeader__qD4X6"};